import {Container, Simbol, Fertilidade, Selo, Relacao, RegraDia} from './styles';

interface DataSimbol {
    comp: string,
    regra?: number,
    click?: any,
    edit: boolean
}

export function Simbols({ comp, regra = 1, click, edit} : DataSimbol){

    
    return(
        <Container edit={edit} fullSpace={comp === 'selo' && true}>
            { comp === 'selo' &&        <Selo><div className={"cor regra"+regra}></div></Selo> }
            { comp === 'simbol' &&      <Simbol         onClick={edit ? () => click() : () => {}}><div className={"regra"+regra}></div></Simbol> }
            { comp === 'fertilidade' && <Fertilidade    onClick={edit ? () => click() : () => {}}><div className={"regra"+regra}></div></Fertilidade> }
            { comp === 'relacao' &&     <Relacao        onClick={edit ? () => click() : () => {}}><div className={"regra"+regra}></div></Relacao> }
            { comp === 'regradia' &&    <RegraDia       onClick={edit ? () => click() : () => {}}><div className={"regra"+regra}></div></RegraDia> }
            {/* comp === 'selo' &&        <Selo           onClick={edit ? () => click() : () => {}}><div className={"regra"+regra}></div></Selo> */}
        </Container>
    )
}